import React, { useState } from 'react';
import './CaseStudiesModal.css';

const CaseStudiesModal = ({ show, onClose }) => {
  const [form, setForm] = useState({ name: '', company: '', industry: '', pain: '' });
  const handleChange = e => setForm({ ...form, [e.target.name]: e.target.value });
  const handleSubmit = e => {
    e.preventDefault();
    // Phase 2: handle gated form submission
    alert('Thank you! Case studies will be sent to your email.');
    onClose();
  };
  if (!show) return null;
  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <button className="close-btn" onClick={onClose}>×</button>
        <h2>Access Case Studies</h2>
        <form onSubmit={handleSubmit}>
          <input name="name" placeholder="Your Name" value={form.name} onChange={handleChange} required />
          <input name="company" placeholder="Company Name" value={form.company} onChange={handleChange} required />
          <input name="industry" placeholder="Industry" value={form.industry} onChange={handleChange} required />
          <textarea name="pain" placeholder="Pain Points" value={form.pain} onChange={handleChange} required />
          <button type="submit">View Case Studies</button>
        </form>
      </div>
    </div>
  );
};

export default CaseStudiesModal;
